<template>
  <div id="contacts">
    <div id="container">
      <div class="box">
        <transition name="fade">
          <div class="content" v-if="contacts.loaded && contacts.error === null">
            <datatable
              v-bind:items="contacts.data"
              v-bind:tableSettings="tableSettings">
            </datatable>

            <pagination
              v-bind:current_page="current_page"
              v-bind:total_pages="total_pages"
              v-bind:next="nextPage"
              v-bind:set="setPage"
              v-bind:prev="prevPage">
            </pagination>
          </div>
        </transition>

        <div class="loader" v-if="!contacts.loaded"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Contacts } from '../../services/api/ApiRoutes';

export default {
  name: 'AllContacts',

  data() {
    // Set page title
    this.$parent.title.heading = this.$t('contacts');
    this.$parent.title.subheading = this.$parent.pickRandom(this.$t('contacts-tagline'));

    return {
      tableSettings: {
        headings: [this.$t('name'), this.$t('email'), this.$t('phone'), this.$t('address'), this.$t('city'), this.$t('company')],
        keys: [
          'fullName',
          function email(contact) {
            return (contact.emails.length > 1) ?
              `${contact.emails[0]} <sup>+${contact.emails.length - 1}</sup>` : contact.emails[0];
          },
          function phone(contact) {
            return (contact.phones.length > 1) ?
              `${contact.phones[0]} <sup>+${contact.phones.length - 1}</sup>` : contact.phones[0];
          },
          function address(contact) {
            return `${contact.address.street} ${contact.address.number}`;
          },
          function city(contact) {
            return contact.address.city;
          },
          function company(contact) {
            return (contact.companies.length > 1) ?
              `${contact.companies[0].name} <sup>+${contact.companies.length - 1}</sup>` :
              contact.companies[0].name;
          },
          function link(contact) {
            return `/contacts/${contact._id}`;
          },
        ],
      },
      contacts: {
        error: null,
        data: [],
        loaded: false,
      },
      per_page: 50,
      current_page: this.$route.query.page || 1,
      total_pages: 1,
    };
  },

  mounted() {
    this.getContacts();
  },

  methods: {
    getContacts() {
      Contacts.getPaged(this.per_page, this.current_page, { _sort: 'fullName' }).then((contacts) => {
        this.contacts.error = null;
        this.contacts.data = contacts.items;
        this.contacts.loaded = true;
        this.total_pages = Math.ceil(contacts.total_count / this.per_page);

        if (this.current_page > this.total_pages) this.setPage(this.total_pages, true);
        if (this.current_page < 1) this.setPage(1, true);
      }).catch((error) => {
        this.contacts.error = error;
        this.contacts.loaded = true;
      });
    },

    nextPage() {
      if (this.current_page === this.total_pages) return;

      this.$parent.scrollToTop();
      this.current_page = parseInt(this.current_page, 10) + 1;
      this.$router.push(`/contacts?page=${this.current_page}`);
      this.getContacts();
    },

    setPage(page, force) {
      if ((this.current_page > this.total_pages || this.current_page < 0) && !force) return;

      this.$parent.scrollToTop();
      this.current_page = parseInt(page, 10);
      this.$router.push(`/contacts?page=${this.current_page}`);
      this.getContacts();
    },

    prevPage() {
      if (this.current_page <= 1) return;

      this.$parent.scrollToTop();
      this.current_page = parseInt(this.current_page, 10) - 1;
      this.$router.push(`/contacts?page=${this.current_page}`);
      this.getContacts();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/contacts/Contacts.vue